import { useMemo } from "react";
import {
  QUERY_OPERATORS,
  FIELD_QUERY_OPERATORS,
} from "../../../logic/services/queryBuilderConfig.js";
import { formatRuleGroupSql } from "../../../logic/services/queryBuilderSql.js";
import { queryBuilderShellStyle } from "./queryBuilderControls.jsx";
import { ReportRuleBuilder } from "./ReportRuleBuilder.jsx";

export function ReportQueryBuilder({
  title,
  hint,
  query,
  onQueryChange,
  fieldNames = [],
  mode = "filter",
  c,
  A,
  dark,
}) {
  const operators = mode === "field" ? FIELD_QUERY_OPERATORS : QUERY_OPERATORS;
  const sqlPreview = useMemo(() => formatRuleGroupSql(query), [query]);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {title ? (
        <div>
          <h3 style={{ margin: "0 0 2px", fontSize: 13, fontWeight: 700, color: c.text }}>{title}</h3>
          {hint ? <p style={{ margin: 0, fontSize: 11, color: c.sub, lineHeight: 1.45 }}>{hint}</p> : null}
        </div>
      ) : null}

      <div style={queryBuilderShellStyle(c, dark)}>
        <ReportRuleBuilder
          query={query}
          onQueryChange={onQueryChange}
          fieldNames={fieldNames}
          operators={operators}
          c={c}
          A={A}
          dark={dark}
        />
      </div>

      {sqlPreview ? (
        <pre
          style={{
            margin: 0,
            padding: "8px 10px",
            borderRadius: 8,
            fontSize: 11,
            lineHeight: 1.5,
            fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
            color: c.mid,
            background: c.card,
            border: `1px solid ${c.divider}`,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
          }}
        >
          {sqlPreview}
        </pre>
      ) : null}
    </div>
  );
}
